/**
 * 视频理赔（新版）坐席端 API：
 * - 按钮展示 / 候选人列表
 * - 邀请 / 取消
 * - 接听 / 拒接 / 呼叫超时
 * - 拍照（截图，后端转存 picture 表）
 */
import { get, post, put, del } from '../utils/http';

/**
 * 获取 邀请视频 按钮前置上下文：
 * - 是否展示 邀请视频 按钮（机构权限 + 案件状态 + 定损状态 + 操作人身份联合判断）
 * - 被邀请候选人（标的 / 三者 / 其他）
 * - 当前 agentId 自己是否存在可取消的邀请
 */
export const getVideoClaimInviteContext = (flowId) =>
    get('/api/lossAss/videoSurvey/inviteContext', { flowId });

/**
 * 发起视频理赔邀请
 * @param {string} flowId 工单受理号
 * @param {'SUBJECT'|'THIRD_PARTY'|'OTHER'} inviteeType 被邀请类型
 * @param {string} inviteePhone 被邀请手机号
 * @param {string} [inviteeName] 被邀请姓名
 * @param {string} [inviteeRef] 标的/三者对应的 ObjectId（OTHER 为空）
 */
export const inviteVideoClaim = ({ flowId, inviteeType, inviteePhone, inviteeName, inviteeRef }) =>
    post('/api/lossAss/videoSurvey/invite', { flowId, inviteeType, inviteePhone, inviteeName, inviteeRef });

/**
 * 取消当前坐席自己发起的 可取消的 视频邀请
 */
export const cancelVideoClaim = (flowId) =>
    put('/api/lossAss/videoSurvey/cancel', { flowId });

/**
 * 坐席接起视频
 */
export const answerVideoClaim = (sessionId) =>
    post(`/api/lossAss/videoSurvey/session/${sessionId}/answer`);

/**
 * 坐席进房拿 TRTC 凭据
 */
export const joinVideoClaim = (sessionId) =>
    post(`/api/lossAss/videoSurvey/session/${sessionId}/join`);

/**
 * 坐席拒接视频
 */
export const rejectVideoClaim = (sessionId) =>
    post(`/api/lossAss/videoSurvey/session/${sessionId}/reject`);

/**
 * 坐席端：呼入超时未接（兜底上报，socket 失败时）
 */
export const markVideoClaimCallingTimeout = (sessionId) =>
    post(`/api/lossAss/videoSurvey/session/${sessionId}/callingTimeout`);

/**
 * 坐席端：上传截图 base64/JPEG 到后端（后端写入 picture 表，本地类目）
 * 因为入门版 TRTC 无法使用 screenshot，由客户端 canvas 截取 remote video frame。
 *
 * @param {string} sessionId 会话Id
 * @param {string} dataUrl  base64 编码的 jpeg 图片（data:image/jpeg;base64,xxxxx）
 * @param {string} takenBy  'agent' | 'customer'
 * @param {string} [label]   默认 本地
 * @param {string} [lossRef] 被邀请方关联的标的/三者loss ID（OTHER 为空）
 */
export const uploadVideoClaimSnapshot = ({ sessionId, dataUrl, takenBy, label, lossRef }) =>
    post(`/api/lossAss/videoSurvey/session/${sessionId}/agentSnapshot`, {
        dataUrl,
        takenBy,
        label,
        lossRef,
    });

/**
 * 拉取当前工单下当前坐席可见的 视频会话（用于打开页面刷新 VideoSurveyRoom 显示）
 */
export const getVideoClaimSessionByFlow = (flowId) =>
    get('/api/lossAss/videoSurvey/session', { flowId });

/**
 * 结束通话（正常结束由客户端先 leave room，再调用此接口记录通话时长等）
 * 若已经通过 TRTC leave/error 事件 leave 也可再调用一次，幂等。
 */
export const endVideoClaimSession = (sessionId) =>
    post(`/api/lossAss/videoSurvey/session/${sessionId}/end`);
